import React from 'react';
import blurpleLogo from '../assets/blurple.png';
import './LandingPage.css';

interface LandingPageProps {
  onEnter: (pov: 'man' | 'woman') => void;
  onOpenRoadmap: () => void;
}

const LandingPage: React.FC<LandingPageProps> = ({ onEnter, onOpenRoadmap }) => {
  return (
    <div className="landing-page">
      <div className="landing-content">
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <div className="logo-container">
          <div className="purple-logo">
            <img src={blurpleLogo} alt="Blurple Logo" className="logo-image" />
          </div>
        </div>
        <br />
        <br />
        <div className="landing-text">
          <h1>Blurple Dating App Demo</h1>
        </div>
        
        <div className="enter-buttons">
          <div className="enter-row">
            <button className="enter-button enter-man" onClick={() => onEnter('man')}>
              Enter as Man
            </button>
            <button className="enter-button enter-woman" onClick={() => onEnter('woman')}>
              Enter as Woman
            </button>
          </div>
          <br />
          <br />
          <br />
          <button className="enter-button enter-roadmap" onClick={onOpenRoadmap}>
            Roadmap
          </button>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
